import { render, staticRenderFns } from "./peasantCircle.vue?vue&type=template&id=41eb66f4&scoped=true"
var script = {}
import style0 from "./peasantCircle.vue?vue&type=style&index=0&id=41eb66f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41eb66f4",
  null
  
)

export default component.exports